import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'

const CustomSnackBar = ({ open, onClose, severity, backgroundColor, message }) => {
  return (
    <Snackbar open={open} autoHideDuration={5000} onClose={onClose}>
        <MuiAlert elevation={6} variant="filled"  onClose={onClose} severity={severity} sx={{ backgroundColor: {backgroundColor},fontSize: '1.2rem', }}>
            {message}
        </MuiAlert>
    </Snackbar>
  );
}

export default CustomSnackBar